import type { Company } from '@pequity/shared/types/company';
import type { UserProfile } from '@pequity/shared/types/user';
import { isProd } from '@pequity/shared/utils/env';
import { pick } from 'lodash-es';

export const pendoSetup = (userProfile: UserProfile, company: Company) => {
  if (isProd && typeof pendo !== 'undefined') {
    const safeUserFields = pick(userProfile, [
      'id',
      'is_admin',
      'is_staff',
      'is_ccp_user',
      'is_teamlead',
      'is_onboarding',
      'has_people_access',
      'default_approver',
      'visible_ranges_count',
      'visible_comp_cycles_count',
      'visible_subordinates_count',
      'staff_mode',
      'has_been_invited',
      'has_accepted_terms',
      'locale',
    ]);

    pendo.initialize({
      visitor: {
        ...safeUserFields,
        feature_permission: JSON.stringify(userProfile.feature_permission),
        app_access: JSON.stringify(userProfile.app_access),
      },
      account: {
        id: userProfile.company_schema_name,
        name: company.name,
        is_free_tier: company.is_free_tier,
      },
    });
  }
};
